const data = {
  mapArea: document.getElementById('imageMap'),
  mapImages: document.querySelectorAll('[data-role="area-img"]'),
  mapCks: document.querySelectorAll('[data-role="area-ck"]'),
};
if (data.mapImages) {
  data.mapImages.forEach(function (mapImage) {
    mapImage.addEventListener('click', function () {
      // クリックした画像の data-area-id を取得
      const clickImageId = mapImage.getAttribute('data-area-id');

      if (mapImage.classList.contains('is-active')) {
        mapImage.classList.remove('is-active');
        data.mapCks.forEach(function (mapCkElement) {
          // const inputElement = mapCkElement.children[0];
          const mapCkId = mapCkElement.getAttribute('id');
          if (mapCkId === clickImageId) {
            mapCkElement.classList.remove('is-active'); // 要素にクラスをトル
            mapCkElement.checked = false;
          }
        });
      } else {
        mapImage.classList.add('is-active');
        data.mapCks.forEach(function (mapCkElement) {
          // const inputElement = mapCkElement.children[0];
          const mapCkId = mapCkElement.getAttribute('id');
          if (mapCkId === clickImageId) {
            mapCkElement.classList.add('is-active'); // 要素にクラスを追加
            mapCkElement.checked = true;
          }
        });
      }

      // チェックボックスの状態を取得
      const checkedMapCks = document.querySelectorAll('.checkbox_for_area_id_search:checked');

      // 全てのチェックボックスがチェックされている場合、全選択チェックボックスをチェック
      // されていない場合、全選択チェックボックスのチェックを外す
      if(data.mapCks.length == checkedMapCks.length) {
        document.querySelector('.checkbox_for_area_all_search').checked = true;
      } else {
        document.querySelector('.checkbox_for_area_all_search').checked = false;
      }
    });
  });

  data.mapCks.forEach(function (mapCk) {
    mapCk.addEventListener('click', function () {
      // クリックした画像の data-area-id を取得
      const clickCkId = mapCk.getAttribute('id');

      if (mapCk.classList.contains('is-active')) {
        mapCk.classList.remove('is-active');
        data.mapImages.forEach(function (mapImageElement) {
          const mapImageID = mapImageElement.getAttribute('data-area-id');
          if (clickCkId === mapImageID) {
            mapImageElement.classList.remove('is-active'); // 要素にクラスをトグル
          }
        });
      } else {
        mapCk.classList.add('is-active');
        data.mapImages.forEach(function (mapImageElement) {
          const mapImageID = mapImageElement.getAttribute('data-area-id');
          if (clickCkId === mapImageID) {
            mapImageElement.classList.add('is-active'); // 要素にクラスをトグル
          }
        });
      }

      // チェックボックスの状態を取得
      const checkedMapCks = document.querySelectorAll('.checkbox_for_area_id_search:checked');

      // 全てのチェックボックスがチェックされている場合、全選択チェックボックスをチェック
      // されていない場合、全選択チェックボックスのチェックを外す
      if(data.mapCks.length == checkedMapCks.length) {
        document.querySelector('.checkbox_for_area_all_search').checked = true;
      } else {
        document.querySelector('.checkbox_for_area_all_search').checked = false;
      }
    });
  });

  const allAreas = document.querySelector('.checkbox_for_area_all_search');
  if (allAreas) {
    allAreas.addEventListener('click', function () {
      const checkedMapCks = document.querySelectorAll('.checkbox_for_area_id_search:checked');

      if(data.mapCks.length == checkedMapCks.length) {
        data.mapCks.forEach(function (e) {
          e.checked = false;
          e.classList.remove('is-active');
        });
        data.mapImages.forEach(function (e) {
          e.classList.remove('is-active');
        });
      } else {
        data.mapCks.forEach(function (e) {
          e.checked = true;
          e.classList.add('is-active');
        });
        data.mapImages.forEach(function (e) {
          e.classList.add('is-active');
        });
      }
    });
  }
}
